import axios from 'axios';
import utility from './utility';

export default {
  name: 'tradingSymbolAutosuggest',
  mixins: [utility],
  methods: {
    tradingSymbolLookup(symbol, tradingSymbolCallBack) {
      const url = this.pd_envConfig.tradingSymbolUrl + symbol;
      const mapObject = {};
      axios.get(url).then((response) => {
        if (response && response.data && response.data.quotes) {
          response.data.quotes.suggestions.forEach((element) => {
            mapObject[element.symbol] = element.cusip;
          });
        }
        tradingSymbolCallBack(mapObject, symbol);
      }).catch(() => {
      });
    },
  },
};
